import request from '@/utils/request';
export default {
    // 获取帮助中心主页数据
    getArticleCenterApi() {
        return request({
            url: `/article/center`,
            method: 'get'
        });
    },

    // 公共中心 - 获取公告中心分类
    queryArticleCategory(params) {
        return request({
            url: `/article/category`,
            method: 'get',
            params
        });
    },

    // 公共中心 - 数据列表
    queryArticleList(params) {
        return request({
            url: `/article/list`,
            method: 'get',
            params
        });
    },

    // 公共中心 - 详情信息
    queryArticleDetail(id) {
        return request({
            url: `/article/detail/${id}`,
            method: 'get'
        });
    }
};
